/**
 *
 * @description Wrapper around 3rd party remote logger
 * Should be able to switch the logger out easily enough
 * if it's required in the future
 *
 * IMPORTANT: For remote logging to work, a client access
 * token must be made available
 * via serverVars.settings.clientRemoteAccessToken
 *
 */

// TODO GROWTH-1214: remove rollbar from dotcom
// We are leaving public interface as noop until we implement new relic

'use strict';

/**
 * @description Supported reporting levels
 * @type {string[]}
 */
var levels = ['error', 'warn', 'debug', 'info', 'log'];

exports.configure = function () {};
exports.configureLogUser = function () {};
exports.init = function () {};

/**
 * @description Get the supported log level strings
 * @returns {string[]}
 */
exports.getLevels = function () {
    return levels;
};

exports.logRemote = function () {};

/**
 * @memberOf module:log
 * @property {Function} error
 * @property {Function} warn
 * @property {Function} debug
 * @property {Function} info
 * @property {Function} log
 */
exports.remote = {};

for (var i = 0; i < levels.length; i++) {
    var level = levels[i];
    exports.remote[level] = function () {};
}

// export to global to support legacy modules
if (typeof window !== 'undefined') {
    window.dibsLog = module.exports;
}




//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/log.js
// module id = 295
// module chunks = 64